"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var factorySvgIcon_1 = __importDefault(require("./utils/factorySvgIcon"));
var SvgHealthierChoiceFilled = function (props) {
    var color = props.color;
    return (React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "m7.711 7.26 3.477-4.843a1 1 0 0 1 1.624 0L16.29 7.26 12 9.833 7.711 7.26Zm-1.17 1.63L4.7 11.454l7.3 4.379 7.299-4.38-1.84-2.563-4.945 2.967a1 1 0 0 1-1.03 0L6.542 8.89Zm13.93 4.194-7.956 4.774a1 1 0 0 1-1.03 0L3.53 13.084l-1.342 1.87a1 1 0 0 0 .293 1.438l9 5.463a1 1 0 0 0 1.038 0l9-5.463a1 1 0 0 0 .294-1.438l-1.343-1.87Z", fill: color }));
};
exports.default = factorySvgIcon_1.default(SvgHealthierChoiceFilled);
//# sourceMappingURL=SvgHealthierChoiceFilled.js.map